import CommonDocument from '@/modules/common/hiring/models/MID/CommonDocument'
import PolicyHolderSaveDocument from '@/modules/common/common/models/MID/PolicyHolderSaveDocument'

export default class SaveDocumentRequest {
  /** (UUID): Identificador único de la cotización. Ejemplo: 23423-643hbf-74834hj. */
  quotationId!: string

  /** Lista de documentos a guardar. */
  document!: CommonDocument[]

  /** Información del titular de la póliza. */
  policyHolder!: PolicyHolderSaveDocument

  constructor(data: any) {
    this.quotationId = data.quotationId
    this.document = data.document?.map((doc: any) => new CommonDocument(doc))
    if (data.policyHolder) this.policyHolder = new PolicyHolderSaveDocument(data.policyHolder)
  }
}
